import './App.css';
import React from 'react';
import Navigation from './Navigation';

function App() {
  return (
    <div className="App">
      <Navigation/>
    </div>
  );
}

export default App;
